export default function Mecanisme() {
  const etapes = [
    "Démontage de la manivelle et du cache de finition du coffre",
    "Accès au treuil interne par l'ouverture latérale ou la trappe de visite",
    "Dépose de l'ancien treuil ou cardan endommagé avec extraction soigneuse",
    "Nettoyage et dégraissage du logement pour éviter les résidus de friction",
    "Pose du nouveau treuil adapté au type de coffre (alu, PVC, acier) et au poids du tablier",
    "Raccordement du cardan de transmission et réglage de la butée de manœuvre",
  ];

  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Remplacement du mécanisme (treuil, cardan, sortie de caisson)
        </h2>
        <p className="text-brand-text leading-relaxed mb-4">
          Le mécanisme d'une manivelle de volet roulant est composé de trois éléments clés : le treuil (l'engrenage interne qui réduit la force et transmet le mouvement), le cardan (l'arbre de liaison entre la manivelle et le treuil) et la sortie de caisson (l'interface visible où s'emboutit la manivelle). Lorsque l'un de ces trois éléments est cassé, l'ensemble de la manœuvre manuelle devient impossible ou très difficile.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Notre équipe de techniciens à Strasbourg et dans le Bas-Rhin intervient avec un stock de treuils universels et de pièces d'origine pour les principales marques de coffres. Nous adaptons le remplacement au type de construction : coffre monobloc, coffre traditionnel à linteau, ou coffre intégré à la maçonnerie. Chaque intervention est réalisée avec des outils de précision pour ne pas endommager le tablier ni les coulisses adjacentes.
        </p>

        <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
          <h3 className="text-lg font-semibold text-brand-blue mb-6 flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan">
              <i className="ri-list-check-2"></i>
            </span>
            Étapes du remplacement du mécanisme de manivelle
          </h3>
          <div className="space-y-4">
            {etapes.map((etape, i) => (
              <div key={i} className="flex items-start gap-4">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-brand-cyan text-white text-sm font-bold shrink-0 mt-0.5">
                  {i + 1}
                </span>
                <p className="text-brand-text text-sm md:text-base leading-relaxed">{etape}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { title: "Treuil", desc: "Engrenage interne qui réduit l'effort de manœuvre. Disponible en plusieurs rapports de démultiplication selon le poids du tablier." },
            { title: "Cardan", desc: "Arbre de transmission flexible ou rigide reliant la manivelle au treuil. Permet l'angle dans les coffres coudés." },
            { title: "Sortie de caisson", desc: "Interface visible où s'emboutit la manivelle. Forme ronde, hexagonale ou carrée selon le fabricant." },
          ].map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-brand-border p-5">
              <h4 className="font-semibold text-brand-blue mb-2">{item.title}</h4>
              <p className="text-sm text-brand-text leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}